import { ApiService } from './api-service';

const TagService =
{
    all(params)
    {
        return ApiService.get('/api/tags', params);
    },

    get(id)
    {
        return ApiService.get(`/api/tags/${id}`);
    },

    update(id, data)
    {
        return ApiService.put(`/api/tags/${id}`, data);
    },

    create(data)
    {
        return ApiService.post('/api/tags', data);
    },

    remove(id)
    {
        return ApiService.delete(`/api/tags/${id}`);
    },
};

export {TagService};
